import React from "react";
import SkeletonBoard, { SkeletonRows } from "./SkeletonBoard";

const BreadcrumbPulse = () => (
  <div className="flex justify-center mb-3 sm:mb-4">
    <div className="h-4 w-64 bg-brand-charcoal/10 rounded animate-pulse" />
  </div>
);

const TournamentPageSkeleton = ({
  cards = 3,
  layout = "stack",
  title,
  subtitle,
}) => {
  if (layout === "overview") {
    return (
      <div role="status" aria-label="Loading tournament">
        <BreadcrumbPulse />
        <SkeletonBoard rows={2} className="mb-6" />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 space-y-6">
            <SkeletonBoard rows={4} />
            <SkeletonBoard rows={3} />
            <SkeletonBoard rows={3} />
          </div>
          <div className="space-y-6">
            <SkeletonBoard rows={5} />
            <SkeletonBoard rows={3} />
          </div>
        </div>
      </div>
    );
  }

  if (title) {
    return (
      <div role="status" aria-label={`Loading ${title}`}>
        <BreadcrumbPulse />
        <div className="space-y-6">
          <div className="card-board overflow-hidden">
            <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
              <h1 className="font-display font-bold text-xl text-brand-cream tracking-tight">
                {title}
              </h1>
              {subtitle ? (
                <p className="text-sm text-brand-mist mt-1">{subtitle}</p>
              ) : null}
            </div>
            <div className="p-6">
              <SkeletonRows count={3} />
            </div>
          </div>
          {Array.from({ length: Math.max(cards - 1, 0) }).map((_, index) => (
            <SkeletonBoard key={index} rows={4} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6" role="status" aria-label="Loading">
      <BreadcrumbPulse />
      {Array.from({ length: cards }).map((_, index) => (
        <SkeletonBoard key={index} rows={index === 0 ? 2 : 4} />
      ))}
    </div>
  );
};

export const AppBootSkeleton = () => (
  <div
    className="flex flex-col min-h-screen bg-brand-cream"
    role="status"
    aria-label="Loading"
  >
    <div className="h-16 border-b border-brand-charcoal/10">
      <div className="h-full px-4 flex items-center">
        <div className="h-8 w-36 bg-brand-charcoal/10 rounded animate-pulse" />
      </div>
    </div>
    <div className="flex-1 p-6">
      <div className="max-w-6xl mx-auto space-y-6">
        <SkeletonBoard rows={2} />
        <SkeletonBoard rows={6} />
      </div>
    </div>
  </div>
);

export const FormFieldsSkeleton = ({ fields = 4 }) => (
  <div className="space-y-6" role="status" aria-label="Loading form">
    <SkeletonRows count={fields} />
    <div className="flex justify-end gap-2 pt-4 border-t border-brand-charcoal/10">
      <div className="h-9 w-20 bg-brand-charcoal/10 rounded-lg animate-pulse" />
      <div className="h-9 w-28 bg-brand-charcoal/10 rounded-lg animate-pulse" />
    </div>
  </div>
);

export default TournamentPageSkeleton;
